export default function() {
  return {
    roles: [],
    role: {
      name: '',
      guard_name: 'api'
    },
    roleList: [],
    
    // permissions
    permissions: [],
    permission: {
      name: '',
      guard_name: 'api',
      group_id: null
    },
    permissionList: [],
    permissionSelected: []
  }
}
